export default "__VITE_ASSET__CfaBbkA9__"